module.exports = __webpack_public_path__ + "static/praktijk1-9360b165a688f98b9d5633d0a29fa768.jpg";